import { Item, SolarCalcPage } from '../solar-calculator';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFChecked from '@/components/UI/svg/blade/calculator/EFChecked';
import NextImage from '@/components/NextImage';

export default function Step4({ calObj, callBack }: any) {
    const { useLang, useState, gtm } = useGlobal();
    const { t } = useLang('calculatorssolarpanels');
    const [checked, setChecked] = useState(calObj?.check4 ?? '');
    const items: Item[] = [
        {
            webp: 'https://websiteoss.ecoflow.com/upload/image/1749092967615/1.jpg',
            img: 'https://websiteoss.ecoflow.com/upload/image/1749092967615/1.jpg',
            text: t('step4_text1'),
            icon: (
                <svg className="item-icon" xmlns="http://www.w3.org/2000/svg" width="42" height="36" viewBox="0 0 42 36" fill="none">
                    <path
                        d="M21.9953 0C24.9602 0 27.4415 2.12814 27.9654 4.97309L37.9194 4.97238C40.1731 4.97238 42 6.79787 42 9.04972V31.9227C42 34.1745 40.1731 36 37.9194 36H4.08057C1.82693 36 0 34.1745 0 31.9227V9.04972C0 6.79787 1.82693 4.97238 4.08057 4.97238L14.032 4.97287C14.5473 2.14444 17.0254 0 20.0047 0H21.9953ZM3.91005 7C2.85516 7 2 7.85701 2 8.91418V32.0858C2 33.143 2.85516 34 3.91005 34H38.0899C39.1448 34 40 33.143 40 32.0858V8.91418C40 7.85701 39.1448 7 38.0899 7H3.91005ZM20 23V25H10V23H20ZM32 20V22.1154H24.2V25H22V20H32ZM20 19V21H10V19H20ZM20 16V18H10V16H20ZM32 16V18H22V16H32ZM21.9961 2H20.0982C18.4374 2 17.0322 3.23503 16.5636 4.93599L16.5471 5H25.5471L25.5373 4.95925C25.0924 3.30899 23.7675 2.09631 22.187 2.00547L21.9961 2Z"
                        fill="white"
                    />
                </svg>
            ),
        },
        {
            webp: 'https://websiteoss.ecoflow.com/upload/image/1749092967852/2.jpg',
            img: 'https://websiteoss.ecoflow.com/upload/image/1749092967852/2.jpg',
            text: t('step4_text2'),
            icon: (
                <svg className="item-icon" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                    <g clipPath="url(#clip0_13_3170)">
                        <path
                            d="M20.8391 19L21.0672 12.3451C21.0954 12.1909 20.9933 12.0431 20.8391 12.0149C20.7278 11.9946 20.6152 12.0423 20.5523 12.1362L9.048 29.3198C8.96081 29.45 8.9957 29.6263 9.12594 29.7135C9.17265 29.7448 9.2276 29.7614 9.28381 29.7614H16.5306L14.4341 42.6491C14.4089 42.8038 14.5139 42.9496 14.6686 42.9748C14.7803 42.9929 14.892 42.943 14.9531 42.8478L24.4239 28.0773"
                            stroke="white"
                            strokeWidth="2"
                        />
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M31.449 3.62719L15.8075 26.497C15.7179 26.628 15.7515 26.8069 15.8825 26.8966C15.9304 26.9293 15.9869 26.9468 16.0449 26.9468H25.5612L22.1682 44.113C22.1374 44.2687 22.2388 44.42 22.3945 44.4508C22.5077 44.4731 22.6233 44.4257 22.6882 44.3302L38.1951 21.4855C38.2843 21.3541 38.2501 21.1753 38.1187 21.0862C38.0711 21.0538 38.0149 21.0365 37.9573 21.0365H28.7536L31.9689 3.84234C31.9981 3.68627 31.8952 3.53608 31.7392 3.50689C31.6271 3.48595 31.5133 3.53313 31.449 3.62719Z"
                            stroke="white"
                            strokeWidth="2"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_13_3170">
                            <rect width="48" height="48" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            ),
        },
    ];

    const handleCheck = (key: number) => {
        setChecked(key === checked ? '' : key);
        callBack({ ...calObj, currentStep: key === checked ? 3 : 4, check4: key === checked ? '' : key });
    };

    const handleBack = () => {
        callBack({ ...calObj, currentPage: SolarCalcPage.Step3, currentStep: 3, check4: undefined }, true);
    };

    const handleNext = () => {
        callBack({ ...calObj, currentPage: SolarCalcPage.Step5 }, true);
        gtm.push({
            event: 'uaEvent',
            event_name: 'checklist_process4',
            step: 'Type',
            product_name: 'EcoFlow Solar Panel',
            button_name: 'Next',
            option_name: items?.find((item: Item) => item.key === checked)?.text,
        });
    };

    return (
        <div className={`step4 ${css.step4}`}>
            <p className="step4-title">{t('step4_title')}</p>
            <ul className="step4-box">
                {items?.map((item: any, k: number) => (
                    <li className="step4-item" key={item?.text} onClick={() => handleCheck(k)}>
                        <div className="img-box">
                            <NextImage webpSrc={item?.webp || item?.img} src={item?.img} alt={item.text} aria-label={item.text} />
                            {item?.icon}
                            {checked === k && (
                                <>
                                    <div className="mask"></div>
                                    <EFChecked className="checked" />
                                </>
                            )}
                        </div>
                        <p className="img-text">{item?.text}</p>
                    </li>
                ))}
            </ul>
            <div className="step4-btns">
                <button className="btn-back" onClick={handleBack}>
                    {t('common_back')}
                </button>
                <button className="btn-next" disabled={!checked && checked !== 0} onClick={handleNext}>
                    {t('common_next')}
                </button>
            </div>
        </div>
    );
}
